import { Injectable } from '@angular/core';
import { FiNotificationService } from '@fi-app/utilities/notification/notification.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { PlatformShutDownNotificationComponent } from '@fi-app/utilities/notification/platform-shut-down-notification/platform-shut-down-notification.component';

@Injectable()
export class PlatformShutDownNotificationService {
    constructor(
        private notificationService: FiNotificationService,
        private customerDataService: FiCustomerDataService,
        private userDataService: FiUserDataService,
    ) {}

    checkShutOffDate() {
        if (
            this.customerDataService.getCustomerData().ShutOffDate &&
            this.userDataService.userData &&
            this.userDataService.userData.IsHeadQuarterUnitMember
        ) {
            return this.notificationService.AddNotification(PlatformShutDownNotificationComponent);
        }
    }
}
